// test1278
(1278 && 0);
